import { StoreAction, XmAction } from 'store/actions';
import { ReturnEligibilityCollection } from './models';

export function returnEligibilityReducer(state: ReturnEligibilityCollection[] = [], action: XmAction<ReturnEligibilityCollection>): ReturnEligibilityCollection[] {
    switch (action.type) {
        case StoreAction.GET_RETURN_ELIGIBILITY_COLLECTION:
            return [ ...state, action.payload ];
        case StoreAction.CLEAR_RETURN_ELIGIBILITY:
            // if no filter then clear all
            if (!action.filters) {
                return undefined;
            }

            return state.filter((returnEligibilty: ReturnEligibilityCollection) => returnEligibilty.orderId !== action.filters.orderId);
        default:
            return state;
    }
}
